import React from 'react';
import { Building, Hammer, TrendingUp, Layers, Network } from 'lucide-react';
import { Link } from 'react-router-dom';
import { companyInfo } from '../mockData';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';

const serviceIcons = {
  1: Building,
  2: Layers,
  3: TrendingUp,
  4: Hammer,
  5: Network
};

export const Services = () => {
  return (
    <div className="flex flex-col">
      {/* Page Header */}
      <section className="bg-gradient-to-b from-blue-50 to-white py-16 sm:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
              Nos services
            </h1>
            <p className="text-lg text-gray-600">
              Des solutions complètes pour tous vos projets de génie civil
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-16 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {companyInfo.services.map((service) => {
              const IconComponent = serviceIcons[service.id];
              return (
                <Card
                  key={service.id}
                  className="border-none shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
                >
                  <CardContent className="pt-8 pb-8">
                    <div className="flex justify-center mb-6">
                      <div className="p-4 bg-blue-50 rounded-full">
                        <IconComponent className="text-blue-600" size={36} />
                      </div>
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">
                      {service.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed text-center">
                      {service.description}
                    </p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 sm:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
              Un projet en tête ?
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              Notre équipe d'experts est prête à vous accompagner dans la réalisation de vos projets de génie civil.
            </p>
            <Link to="/contact">
              <Button
                size="lg"
                className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-6 text-lg font-semibold transition-colors duration-200 shadow-lg hover:shadow-xl"
              >
                Demander un devis gratuit
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};
